<template>
  <v-dialog v-model="isOpen" max-width="400px" persistent>
    <v-card>
      <v-card-title class="text-h6 d-flex align-self-center justify-between">
        <span>
        {{ serverName.toUpperCase() === 'ISIDE' ? 'OCC Server Status Details' : 'BOCC Server Status Details' }}
        </span>
      </v-card-title>

      <v-card-text style="text-align: center">
        <div v-if="loading" class="text-center pa-5">
          <v-progress-circular color="primary" indeterminate/>
          <div class="mt-2">Loading server data...</div>
        </div>

        <div v-else-if="error" class="text-error pa-5 text-center">
          <v-icon color="error" size="32">mdi-alert-circle</v-icon>
          <div class="mt-2">{{ error }}</div>
        </div>

        <div v-else>
          <v-list dense>
            <v-list-item v-for="(value, key) in serverData" :key="key">
              <v-list-item-title>{{ key }}:</v-list-item-title>
              <v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn variant="plain" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import {ref, watch, defineProps, defineEmits} from 'vue'
import axios from 'axios'

const props = defineProps({
  modelValue: Boolean,
  serverName: String
})

const emit = defineEmits(['update:modelValue'])

const isOpen = ref(props.modelValue)
const loading = ref(false)
const error = ref(null)
const serverData = ref({status: '', details: {}})

watch(() => props.modelValue, val => {
  isOpen.value = val
  if (val) fetchServerHealth()
})

watch(isOpen, val => emit('update:modelValue', val))

async function fetchServerHealth() {
  if (!props.serverName) return
  loading.value = true
  error.value = null
  serverData.value = {}

  try {
    const baseUrls = {
      iside: 'https://metrocairo4-iside-api/actuator/health',
      osiride: 'https://metrocairo4-osiride-api/actuator/health',
      // iside: 'http://localhost:8090/actuator/health',
      // osiride: 'http://localhost:8090/actuator/health',
    }

    const url = baseUrls[props.serverName.toLowerCase()]
    if (!url) throw new Error(`No health endpoint defined for ${props.serverName}`)

    const {data} = await axios.get(url)
    serverData.value = getStatus(data)
  } catch (err) {
    if (err.status === 503) {
      serverData.value = getStatus(err.response.data)
    } else {
      error.value = err.message || 'Failed to fetch server health.'
    }
  } finally {
    loading.value = false
  }
}

function getStatus(data) {
  const freeSpace = (data.components.diskSpace.details.free / 1000000000).toFixed(2);
  const totalSpace = (data.components.diskSpace.details.total / 1000000000).toFixed(2);

  var myStatus = {
    "Overall Status": data.status,
    "Database": data.components.db.status,
    "Train Alarm System": data.components.mqttHealth.status,
    "Disk": data.components.diskSpace.status + " (" + freeSpace + "GB free out of " + totalSpace + "GB)",
    "Backend Ping": data.components.ping.status
  }

  return myStatus;
}

function closeDialog() {
  isOpen.value = false
}
</script>
